<script>
  import Icon from "svelte-awesome";
  import { userPlus } from "svelte-awesome/icons";
  import AddFloorResourceModal from "../AddFloorResourceModal.svelte";
  export let floorid;
  export let floorname;
  export let deliverableid;
  export let floorStatus;
  let openAddResource = false;
  const toggleAddResource = () => (openAddResource = !openAddResource);
</script>

<button style="border: none;" on:click={toggleAddResource}>
  <Icon data={userPlus} scale={1} />
</button>

<AddFloorResourceModal
  toggle={toggleAddResource}
  open={openAddResource}
  id={floorid}
  name={floorname}
  deliverable={deliverableid}
  {floorStatus}
  on:floorUpdated
  on:resourceassigned />
